/**
 * WEBM.
 *
 *
 * @beta
 */
export const WEBM = 'webm'
